import './index.less';
// style dependencies
import '../../empty/style';
import '../../spin/style';
